import * as _ from "lodash";
import ReactHtmlParser from 'react-html-parser';
import { CONFIG } from "../config/gameplay";
import React from "react";
import ReactMarkdown from "react-markdown";

export const MESSAGE_TYPES = {
  TEXT: "TEXT",
  IMAGE: "IMAGE"
};

export const SENDER_TYPES = {
  HTML: "HTML",
  INCOMING: "INCOMING",
  OUTGOING: "OUTGOING"
};

export default class Message {
  constructor(text, pid, index) {
    //Allow JSON reassignment
    if (arguments.length === 1) {
      _.assign(this, text);
      return
    }

    this.pid = pid;
    this.messageIndex = index;

    const commandsMatch = text.match(/\{(.*)\}/);

    this.text = text.replace(/{{(.*?)}}/, "").trim();

    if (_.startsWith(text, "{{nobox}}") || _.startsWith(text, "{{html}}")) {
      this.senderType = SENDER_TYPES.HTML;
      return;
    }

    if (commandsMatch) {
      const commands = eval("(" + commandsMatch[1] + ")");
      if (commands.wait) {
        this.waitTime = commands.wait * 1000;
      }

      this.isTyping = commands.isTyping;
    }

    this.senderType = _.includes(text, "[[") ? SENDER_TYPES.OUTGOING : SENDER_TYPES.INCOMING;

    const isImage = _.includes(text, "<img");
    this.type = isImage ? MESSAGE_TYPES.IMAGE : MESSAGE_TYPES.TEXT;

    if (this.senderType === SENDER_TYPES.OUTGOING) {
      this.text = this.text.replace("[[", "").trim();
      this.text = this.text.replace("]]", "").trim();
      const raw = this.text.split(/->/);
      this.text = raw[0];
      this.nextPassageName = raw[1];
    }
  }

  get isAwayMessage() {
    return this.waitTime !== undefined;
  }

  isIncoming() {
    return this.senderType === SENDER_TYPES.INCOMING
  }

  isHtml() {
    return this.senderType === SENDER_TYPES.HTML
  }

  isOutgoing() {
    return this.senderType === SENDER_TYPES.OUTGOING
  }

  isImage() {
    return this.type === MESSAGE_TYPES.IMAGE
  }

  get id() {
    return this.pid + this.messageIndex;
  }

  get previewText() {
    if (this.type === MESSAGE_TYPES.IMAGE) return "📷 Photo";
    if (this.senderType === SENDER_TYPES.HTML) return <div dangerouslySetInnerHTML={{ __html: this.text }}/>;
    else return <ReactMarkdown source={this.text}/>;
  }

  getSourceFromImage() {
    return ReactHtmlParser(this.text)[0].props.src
  }

  getWaitUntilSent() {
    if (this.type === MESSAGE_TYPES.IMAGE) {
      return CONFIG.IMAGE_DEFAULT_WAIT
    }

    if (this.isHtml()) {
      return CONFIG.HTML_MESSAGE_DEFAULT_WAIT
    }

    const defaultWait = this.text.length * CONFIG.TYPING_DELAY_BY_CHARACTER;
    return this.waitTime || defaultWait;
  }

  getIsTyping() {
    if (this.waitTime > 0) return this.isTyping;
    return true
  }

  type;
  senderType;
  text;
  links;
  nextPassageName;
  pid;
  messageIndex;
  timeOfArrival;
  waitTime;
  isTyping;
}